<ng-container *sbPageAction>
  <ng-container *ngIf="!isInModalContext">
    <a [sbRouterLink]="util.RoutingID.campaigns">
      <sb-button classes="btn-default btn-sm text-uppercase">{{ 'lang.globals.back' | translate }}
      </sb-button>
    </a>
  </ng-container>
</ng-container>
<sb-comp-ccr-hero *ngIf="!isInModalContext" [ccr]="selectedCampaign"
                  [isCollapsed]="true"></sb-comp-ccr-hero>
<div *ngIf="!exportState" class="row">
  <div class="col-12">
    <sb-card [classes]="'stickyHeader'" [loadingDelay]="1" [loading]="loading">
      <div card-header>
        <h3>
          <sb-icon [dualColor]="true" class="mr-2" icon="commercial"></sb-icon>
          {{ 'lang.globals.commercials' | translate }}
        </h3>
        <small>{{ paginationString }}</small>
      </div>
      <div card-header-more>
        <div class="d-flex align-items-center">
          <ng-container *ngIf="!orderMode">
            <sb-local-date-range-input class="mr-2" [from]="from" [till]="till" [showSubmit]="true" [today]="null" [allowEmpty]="true"
                                       (dateChange)="handleDateChange($event)"></sb-local-date-range-input>
            <sb-boolean-toggles (toggleChange)="boolChange($event?.id, $event?.value)" [viewMode]="'dropdown'"
                                [toggles]="initialBooleans"
                                class="mr-1">
              {{ 'lang.globals.statusFilter' | translate }}
            </sb-boolean-toggles>
            <sb-comp-dropdown-select
              *ngPermissions="permissionService.Permission.cull_list"
              [singleSelectMode]="false"
              [inputData]="contentCulls" [dropDownDatatype]="'CONTENT_CULLS'"
              (selectedDataEmitter)="update($event, 'CONTENT_CULLS')" [showColumnIcon]="false"
              [msOptions]="msContentCullOptions" (msOptionsChange)="msRequest('CONTENT_CULLS', $event)"
              [selectedInputData]="selectedContentCulls ? selectedContentCulls : []">
            </sb-comp-dropdown-select>
            <sb-comp-dropdown-select
              *ngPermissions="permissionService.Permission.cull_list"
              [showSubmit]="false" [singleSelectMode]="true"
              [inputData]="timeCulls" [dropDownDatatype]="'TIME_CULLS'"
              (selectedDataEmitter)="update($event, 'TIME_CULLS')" [showColumnIcon]="false"
              [msOptions]="msTimeCullOptions" (msOptionsChange)="msRequest('TIME_CULLS', $event)"
              [selectedInputData]="selectedTimeCull ? [selectedTimeCull] : []">
            </sb-comp-dropdown-select>
            <sb-comp-dropdown-select
              *ngPermissions="permissionService.Permission.cull_list"
              [showSubmit]="false" [singleSelectMode]="true"
              [inputData]="geoCulls" [dropDownDatatype]="'GEO_CULLS'"
              (selectedDataEmitter)="update($event, 'GEO_CULLS')" [showColumnIcon]="false"
              [msOptions]="msGeoCullOptions" (msOptionsChange)="msRequest('GEO_CULLS', $event)"
              [selectedInputData]="selectedGeoCull ? [selectedGeoCull] : []">
            </sb-comp-dropdown-select>
            <sb-comp-dropdown-select
              *ngPermissions="permissionService.Permission.cull_list"
              [showSubmit]="false" [singleSelectMode]="true"
              [inputData]="playerCulls" [dropDownDatatype]="'PLAYER_CULLS'"
              (selectedDataEmitter)="update($event, 'PLAYER_CULLS')" [showColumnIcon]="false"
              [msOptions]="msPlayerCullOptions" (msOptionsChange)="msRequest('PLAYER_CULLS', $event)"
              [selectedInputData]="selectedPlayerCull ? [selectedPlayerCull] : []">
            </sb-comp-dropdown-select>
            <!-- TODO permission check for export commercials -->
            <button (click)="selectionForExport()" *ngIf="!isInModalContext" class="btn btn-primary mr-2">
              <sb-icon icon="download"></sb-icon>
              {{ 'lang.globals.export'|translate }}
            </button>
          </ng-container>
          <!--
                    <a #Arrangement orderOption="Arrangement" (click)="setToOrder($event, Arrangement)" class="px-1">
                      <sb-button classes="btn-hover-primary">
                        <sb-icon
                            *ngIf="orderOption?.caption===Arrangement.attributes.getNamedItem('orderOption').value && orderDirection === 'desc'"
                            icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
                        <sb-icon
                            *ngIf="orderOption?.caption===Arrangement.attributes.getNamedItem('orderOption').value && orderDirection !== 'desc'"
                            icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
                        <sb-icon
                            *ngIf="!(orderOption?.caption===Arrangement.attributes.getNamedItem('orderOption').value)"
                            icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
                      </sb-button>
                    </a>
                    -->
          <ng-container *ngIf="!isInModalContext">
            <ng-container *ngPermissions="permissionService.Permission.campaign_edit">
              <ng-container *ngIf="orderingAvailable || loading">
                <sb-button (click)="startOrdering()" *ngIf="!orderMode" icon="drag"
                           classes="btn btn-primary text-uppercase mr-2" [disabled]="loading">
                  {{ 'lang.commercialsList.changeOrder' | translate }}
                </sb-button>
                <sb-button (submitClicked)="applyOrdering()" *ngIf="orderMode" [disabled]="!orderChanged || loading"
                           classes="btn btn-success text-uppercase mr-2">
                  {{ 'lang.commercialsList.applyOrder' | translate }}
                </sb-button>
                <sb-button (click)="cancelOrdering()" *ngIf="orderMode" classes="btn btn-danger text-uppercase mr-2" [disabled]="loading">
                  {{ 'lang.commercialsList.cancelOrder' | translate }}
                </sb-button>
              </ng-container>
              <a *ngIf="!orderMode"
                 [queryParams]="{ returnTo: this.util?.getPageLink(), from: this.from, till: this.till, playerCullSet: this.selectedPlayerCull?.id, geoCullSet: this.selectedGeoCull?.id, timeCullSet: this.selectedTimeCull?.id}"
                 [sbRouterLink]="util.RoutingID.commercialsCreate">
                <sb-button classes="btn-success mr-0">
                  <sb-icon class="mr-1" icon="plus"></sb-icon>
                  {{ 'lang.commercialsList.newCommercial' | translate }}
                </sb-button>
              </a>
            </ng-container>
          </ng-container>
        </div>
        <div class="tw-flex tw-items-center tw-mt-2 tw-justify-end">
          <span>{{ 'lang.globals.order' | translate }}</span>
          <select [ngModel]="orderOption" (ngModelChange)="setToOrder($event.value)"
                  class="form-select tw-mx-2 tw-w-fit">
            <option *ngFor="let option of allOrderOptions" [ngValue]="option"
                    [selected]="orderOption.value === option.value">{{ option.label }}
            </option>
          </select>
          <button class="btn btn-default" (click)="setToOrder(orderOption.value)">
            <sb-icon
              *ngIf="orderOption.direction === 'desc'"
              icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
            <sb-icon
              *ngIf="orderOption.direction !== 'desc'"
              icon="arrowUpAlt" class="icon-in-btn"></sb-icon>

          </button>
        </div>
      </div>
      <div card-fit>
        <ng-container *ngIf="loading">
          <sb-ghost-list [ghosts]="ghosts"></sb-ghost-list>
        </ng-container>
        <div *ngIf="!loading && (!commercials || commercials?.length === 0) && !isInModalContext"
             class="tw-flex tw-justify-center tw-items-center tw-h-28">
          <span class="tw-italic tw-opacity-50">{{ 'lang.commercialsList.noCommercialsFound' | translate }}</span>
        </div>
        <ng-container *ngIf="commercials && commercials?.length > 0">
          <div *ngIf="commercials">
            <ng-scrollbar
              [autoHeightDisabled]="false"
              [track]="'horizontal'"
            >

              <table class="table mb-3">
                <thead>
                <tr>
                  <th *ngIf="(discussionService.showRibbon || discussionService.showDiscussionSideBar) &&
                !isInModalContext"
                      class="sticky-col first-col tableBg"></th>
                  <th *ngIf="orderMode">&nbsp;</th>
                  <th *ngIf="!orderMode">
                    {{ 'lang.globals.orderNumber' | translate }}
                  </th>
                  <th class="table--sortable" (click)="setToOrder('Title')"
                      [ngClass]="{'table--sorted': orderOption?.value==='Title'}">
                    {{ 'lang.globals.commercial' | translate }}
                    @if (orderOption.value === 'Title') {
                      <sb-icon
                        *ngIf="orderOption.direction === 'desc'"
                        icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
                      <sb-icon
                        *ngIf="orderOption.direction !== 'desc'"
                        icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
                    } @else {
                      <sb-icon
                        icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
                    }
                  </th>
                  <th>{{ 'lang.globals.duration' | translate }}</th>
                  <th>{{ 'lang.commercialEdit.frequency' | translate }}</th>
                  <th>{{ 'lang.globals.verification' | translate }}</th>
                  <th class="table--sortable" (click)="setToOrder('From')"
                      [ngClass]="{'table--sorted': orderOption?.value==='From'}">
                    {{ 'lang.globals.timingProgress' | translate }}
                    @if (orderOption.value === 'From') {
                      <sb-icon
                        *ngIf="orderOption.direction === 'desc'"
                        icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
                      <sb-icon
                        *ngIf="orderOption.direction !== 'desc'"
                        icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
                    } @else {
                      <sb-icon
                        icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
                    }
                  </th>
                  <th *ngPermissions="permissionService.Permission.ds_cm_reporting"
                      class="d-xxl-table-cell d-none">{{ 'lang.globals.playoutPulse' | translate }}
                  </th>
                  <th>{{ 'lang.globals.playouts' | translate }}</th>
                  <th>{{ 'lang.globals.filter' | translate }}</th>
                  <th class="d-xl-table-cell d-none">{{ 'lang.globals.locationsScreens' | translate }}</th>
                  <th class="d-xxl-table-cell d-none table--sortable"
                      (click)="setToOrder('Modified')"
                      [ngClass]="{'table--sorted': orderOption?.value==='Modified'}">
                    {{ 'lang.globals.modifiedAt' | translate }}
                    @if (orderOption.value === 'Modified') {
                      <sb-icon
                        *ngIf="orderOption.direction === 'desc'"
                        icon="arrowDownAlt" class="icon-in-btn"></sb-icon>
                      <sb-icon
                        *ngIf="orderOption.direction !== 'desc'"
                        icon="arrowUpAlt" class="icon-in-btn"></sb-icon>
                    } @else {
                      <sb-icon
                        icon="arrowsExchangeVAlt" class="icon-in-btn"></sb-icon>
                    }
                  </th>
                  <th class="text-end"></th>
                </tr>
                </thead>
                <tbody (cdkDropListDropped)="drop($event)" [cdkDropListDisabled]="!orderMode" cdkDropList>
                <tr *ngFor="let commercial of commercials; index as i; last as last"
                    [ngClass]="{'tw-opacity-50' : !commercial.active}"
                    cdkDrag>
                  <td *ngIf="(discussionService.showRibbon || discussionService.showDiscussionSideBar) && !isInModalContext"
                      [entityElement]="{type: discussionService.DISCUSSABLES.Commercial, element: commercial}"
                      [inTable]="true"
                      [inline]="true"
                      class="sticky-col first-col tableBg" sb-discussion>
                  </td>
                  <td *ngIf="orderMode" cdkDragHandle style="cursor: move;">
                    <sb-icon icon="drag"></sb-icon>
                  </td>
                  <td *ngIf="!orderMode">{{ commercial.sequence + 1 }}</td>
                  <td>
                    <div class="d-flex align-items-center">
                      <sb-action-required [bookingStatus]="commercial.bookingStatus" class="mr-4"></sb-action-required>
                      <sb-comp-image-name-wrapper [medium]="commercial?.preview" [still]="true">
                        <sb-comp-link [link]="util.RoutingID.requirements"
                                      [queryParams]="{contentCulls: queryParamService.getQueryParam('contentCulls')}"
                                      [pathParams]="[{id: 'campaignID', value: campaignId},{id: 'commercialID', value: commercial?.id}]"
                                      [title]="(commercial?.name | truncate : 23)"
                                      [tooltip]="'lang.globals.details' | translate"
                                      firstLine>
                        </sb-comp-link>
                        <ng-container *ngIf="commercial?.requirementCount > 1" secondLine>
                          <div>
                            {{ commercial?.requirementCount }} {{ 'lang.globals.requirements'| translate }}
                          </div>
                        </ng-container>
                        <span thirdLine [innerHTML]="commercial?.identifier | truncate:30"></span>
                        <span fourthLine [innerHTML]="commercial?.description | truncate:30"></span>
                        <sb-tags *ngPermissions="[permissionService.Permission.tag_list]" [dtoId]="commercial.id"
                                 [dtoType]="tagService.TaggableDTO.Commercial"
                                 [tags]="commercial.tags" fifthLine></sb-tags>
                      </sb-comp-image-name-wrapper>
                    </div>
                  </td>
                  <td>
                    {{ commercial.duration }} s
                  </td>
                  <td>
                    {{ commercial.frequency }}
                  </td>
                  <td style=" width: 118px;">
                    <sb-verification-progress [bookingStatus]="commercial.bookingStatus"></sb-verification-progress>
                  </td>
                  <td>
                    <sb-comp-progressbar-wrapper [campaignOrCommercial]="commercial"></sb-comp-progressbar-wrapper>
                  </td>
                  <td *ngPermissions="permissionService.Permission.ds_cm_reporting" class="d-xxl-table-cell d-none"
                      style="width: 180px;">
                    <sb-line-small-chart *ngIf="commercial?.reporting?.loadingDone"
                                         [chartData]="commercial.reporting"></sb-line-small-chart>
                  </td>

                  <td>
                    <sb-comp-playout-aggregation [playoutAggregation]="commercial?.playoutAggregation"></sb-comp-playout-aggregation>
                  </td>
                  <td>
                    <sb-comp-filter-overview [geoCull]="commercial?.geoCull" [playerCull]="commercial?.playerCull"
                                             [stateSpaceCull]="commercial?.stateSpaceCull"
                                             [timeCull]="commercial?.timeCull"
                                             hideClass="d-xxl"></sb-comp-filter-overview>
                  </td>
                  <td class="d-xl-table-cell d-none">
                    <div class="filter">
                      <div class="filter__sum">
                        <div class="filter__sum__item">
                          <sb-icon icon="location"></sb-icon>
                          {{ commercial?.playerAggregation?.locations | sbNumberFormat }}
                        </div>
                        /
                        <div class="filter__sum__item">
                          <sb-icon icon="screen"></sb-icon>
                          {{ commercial?.playerAggregation?.screens | sbNumberFormat }}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="d-xxl-table-cell d-none">
                    <sb-comp-display-modified [data]="commercial"></sb-comp-display-modified>
                  </td>
                  <td class="text-end sticky-col last-col tableBg">
                    <sb-table-buttons>
                      <ng-container *ngIf="!isInModalContext">
                        <a
                          [queryParams]="{contentCulls: queryParamService.getQueryParam('contentCulls')}"
                          [pathParams]="[{id: 'campaignID', value: campaignId}, {id: 'commercialID', value: commercial?.id}]"
                          [sbRouterLink]="util.RoutingID.requirements" class="btn-primary btn"
                          container="body"
                          ngbTooltip="{{ 'lang.globals.details' | translate }}">
                          <sb-icon icon="details"></sb-icon>
                        </a>
                        <ng-container *ngPermissions="permissionService.Permission.campaign_edit">
                          <a [pathParams]="[{id: 'campaignID', value: campaignId}, {id: 'commercialID', value: commercial?.id}]"
                             [queryParams]="{ returnTo: this.util?.getPageLink(), from: this.from, till: this.till, playerCullSet: this.selectedPlayerCull?.id, geoCullSet: this.selectedGeoCull?.id, timeCullSet: this.selectedTimeCull?.id}"
                             [sbRouterLink]="util.RoutingID.commercialsEdit"
                             class="btn-secondary btn"
                             container="body"
                             ngbTooltip="{{'lang.globals.editCommercial' | translate}}">
                            <sb-icon icon="edit"></sb-icon>
                          </a>
                        </ng-container>
                        <ng-container *ngPermissions="permissionService.Permission.campaign_edit">
                          <a [pathParams]="[{id: 'campaignID', value: campaignId}, {id: 'commercialID', value: commercial?.id}]"
                             [queryParams]="{ returnTo: this.util?.getPageLink(), skipToBooking: true}"
                             [sbRouterLink]="util.RoutingID.commercialsEdit"
                             class="btn-default btn"
                             container="body"
                             ngbTooltip="{{'lang.globals.bookings' | translate}}">
                            <sb-icon icon="bookings"></sb-icon>
                          </a>
                        </ng-container>
                        <ng-container *ngPermissions="permissionService.Permission.campaign_edit">
                          <a class="btn-info btn"
                             (click)="copyCommercialModal(commercial)"
                             container="body"
                             ngbTooltip="{{'lang.globals.copyCommercial' | translate}}">
                            <sb-icon icon="copy"></sb-icon>
                          </a>
                        </ng-container>
                        <ng-container *ngPermissions="permissionService.Permission.campaign_delete">
                          <a (click)="deleteCommercial(commercial)" class="btn-danger btn"
                             container="body"
                             ngbTooltip="{{ 'lang.globals.deleteCommercial' | translate }}">
                            <sb-icon [icon]="'trash'"></sb-icon>
                          </a>
                        </ng-container>
                        <ng-container *ngPermissions="permissionService.Permission.campaign_edit">
                          <button (click)="toggleCommercialEnabled(commercial, !commercial.active)"
                                  (mouseenter)="commercial.isHover= true"
                                  (mouseleave)="commercial.isHover = false"
                                  [ngClass]="commercial.active ? 'btn-success' : 'btn-warning' "
                                  class="btn btn-info ml-2"
                                  style="width: calc(1.35em + 1.1rem + 7px);padding: 0 !important;height: calc(1.35em + 1.1rem + 5px);">
                            <sb-icon *ngIf="commercial.active" [hover]="commercial.isHover"
                                     [icon]="'playToPauseAnimation'"></sb-icon>
                            <sb-icon *ngIf="!commercial.active" [hover]="commercial.isHover"
                                     [icon]="'pauseToPlayAnimation'"></sb-icon>
                          </button>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngIf="isInModalContext">
                        <a (click)="selectCommercial(commercial)"
                           class="btn btn-hover-primary" container="body"
                           ngbTooltip="{{'lang.globals.select' | translate}}">
                          <sb-icon
                            *ngIf="util.arrayToIdArray(selectedCommercials) &&
                                      util.arrayToIdArray(selectedCommercials)?.indexOf(commercial.id)!==-1"
                            [icon]="'boxChecked'"></sb-icon>
                          <sb-icon
                            *ngIf="!util.arrayToIdArray(selectedCommercials) ||
                                      util.arrayToIdArray(selectedCommercials)?.indexOf(commercial.id)===-1"
                            [icon]="'box'"></sb-icon>
                        </a>
                      </ng-container>
                    </sb-table-buttons>
                  </td>

                    <div *cdkDragPreview class="tw-opacity-20" style="background: #fff">
                    <table class="table">
                      <tbody>
                      <tr>
                        <td *ngIf="orderMode">
                          <sb-icon icon="drag"></sb-icon>
                        </td>
                        <td>
                          <sb-action-required [bookingStatus]="commercial.bookingStatus"></sb-action-required>
                        </td>
                        <td>
                          <sb-comp-image-name-wrapper [medium]="commercial?.preview">
                            <span firstLine>{{ commercial?.name }}</span>
                            <span *ngIf="commercial?.requirementCount > 1"
                                  secondLine>{{
                                commercial?.requirementCount === 1 ? 'Requirement' :
                                  'Requirements'
                              }}</span>
                          </sb-comp-image-name-wrapper>
                        </td>
                        <td>
                          <sb-verification-progress [bookingStatus]="commercial.bookingStatus"></sb-verification-progress>
                        </td>
                        <td>
                        <span *ngIf="commercial.timingStatus==='Future'"
                              class="badge blue">{{ 'lang.globals.planned' | translate }}</span>
                          <span *ngIf="commercial.timingStatus==='Present'"
                                class="badge green">{{ 'lang.globals.running' | translate }}</span>
                          <span *ngIf="commercial.timingStatus==='Past'"
                                class="badge grey">{{ 'lang.globals.expired' | translate }}</span>
                          <span *ngIf="commercial.timingStatus==='Unknown'"
                                class="badge grey">{{ 'lang.globals.noTiming' | translate }}</span>
                        </td>
                        <td>{{ commercial?.from?.toString() | date: 'dd.MM.yy HH:mm' }}</td>
                        <td>{{ commercial?.till?.toString() | date: 'dd.MM.yy HH:mm' }}</td>
                        <td>
                          <sb-comp-filter-overview
                            [geoCull]="commercial?.geoCull"
                            [playerCull]="commercial?.playerCull" [stateSpaceCull]="commercial?.stateSpaceCull"
                            [timeCull]="commercial?.timeCull"></sb-comp-filter-overview>
                        </td>
                        <td class="d-xl-table-cell d-none">
                          <div class="filter">
                            <div class="filter__sum">
                              <div class="filter__sum__item">
                                <sb-icon icon="location"></sb-icon>
                                {{ commercial?.playerAggregation?.locations | sbNumberFormat }}
                              </div>
                              /
                              <div class="filter__sum__item">
                                <sb-icon icon="screen"></sb-icon>
                                {{ commercial?.playerAggregation?.screens | sbNumberFormat }}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td
                          class="d-xxl-table-cell d-none">{{ commercial?.createdAt?.toString() | date: 'dd.MM.yy HH:mm:ss' }}
                        </td>
                        <td class="text-end">
                          <div class="d-flex align-items-center">
                            <a
                              [queryParams]="{contentCulls: queryParamService.getQueryParam('contentCulls')}"
                              [pathParams]="[{id: 'campaignID', value: campaignId}, {id: 'commercialID', value: commercial?.id}]"
                              [sbRouterLink]="util.RoutingID.requirements"
                              container="body"
                              ngbTooltip="{{'lang.globals.details'|translate}}" placement="left">
                              <sb-button classes="btn-hover-primary mr-1">
                                <sb-icon [icon]="'details'"></sb-icon>
                              </sb-button>
                            </a>
                            <ng-container *ngPermissions="permissionService.Permission.campaign_edit">
                              <a
                                [pathParams]="[{id: 'campaignID', value: campaignId}, {id: 'commercialID', value: commercial?.id}]"
                                [sbRouterLink]="util.RoutingID.commercialsEdit"
                                container="body"
                                ngbTooltip="{{'lang.globals.editCommercial' | translate}}" placement="left">
                                <sb-button classes="btn-hover-primary mr-1">
                                  <sb-icon [icon]="'edit'"></sb-icon>
                                </sb-button>
                              </a>
                            </ng-container>
                            <ng-container *ngPermissions="permissionService.Permission.campaign_delete">
                              <a (click)="deleteCommercial(commercial)"
                                 ngbTooltip="{{'lang.globals.deleteCommercial'|translate}}" placement="left">
                                <sb-button classes="btn-danger mr-3">
                                  <sb-icon [icon]="'trash'"></sb-icon>
                                </sb-button>
                              </a>
                            </ng-container>
                            <div class="form-check form-switch online d-inline">
                              <input (ngModelChange)="toggleCommercialEnabled(commercial, $event)"
                                     [(ngModel)]="commercial.active" [id]='"customSwitch" + commercial.id'
                                     class="form-check-input" role="switch"
                                     type="checkbox">
                              <label [for]='"customSwitch" + commercial.id' class="form-check-label"></label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </tr>
                </tbody>
              </table>
            </ng-scrollbar>
          </div>
        </ng-container>
      </div>
      <div *ngIf="isInModalContext" card-footer>
        <div class="row">
          <div class="col-8">
            <div class="row" style="height: 100%; display: flex; align-items: center;">
              <div *ngFor="let e of selectedCommercials" class="col-3">
                <a [innerHTML]="e.name | truncate : 25" class="font-weight-bold link mr-2"
                   style="white-space: nowrap; height: 30px;"></a>
              </div>
            </div>
          </div>
          <div class="col-4 justify-content-end d-flex align-items-center">
            <span
              class="mr-2 font-weight-bold text-dark">{{ selectedCommercials?.length }}
              {{ 'lang.globals.selected' | translate }}</span>
            <button (click)="deselectCommercials()" [disabled]="selectedCommercials?.length < 1"
                    class="btn btn-danger btn-sm mr-1">{{ 'lang.globals.deselectAll' | translate }}
            </button>
            <button (click)="returnSelectedCommercials()" [disabled]="selectedCommercials?.length < 1"
                    class="btn btn-primary btn-sm">{{ 'lang.globals.save' | translate }}
            </button>
          </div>
        </div>
      </div>
    </sb-card>
  </div>
</div>


<div *ngIf="exportState">
  <form [formGroup]="form" class="wizard__forms pr-5 pl-5">
    <div class="row">
      <div class="col">
        <div class="form-group validateMe">
          <label class="form-label" for="Title">{{ 'lang.globals.title' | translate }}</label>
          <input class="form-control" formControlName="Title" id="Title" sbAutofocus
                 type="text">
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <sb-local-date-time-input
            (modelChange)="localDateTimeInputFrom($event)" [kind]="'RANGE_START'"
            [seconds]="false"
            [title]="translate.instant('lang.globals.startTime')">
          </sb-local-date-time-input>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <sb-local-date-time-input
            (modelChange)="localDateTimeInputTill($event)" [kind]="'RANGE_END'"
            [minDate]="reportFrom"
            [seconds]="false"
            [title]="translate.instant('lang.globals.dueTime')"></sb-local-date-time-input>
        </div>
      </div>
    </div>
    <div class="wizard__footerActions mb-3 d-flex justify-content-end">
      <button (click)="returnSelectedCommercials()" class="btn btn-primary btn-sm">
        {{ 'lang.globals.save' | translate }}
      </button>
    </div>
  </form>
</div>
